/**
 * Combined write-audit API (owner-only).
 *
 * GET /api/write-audit merges every per-feature write-audit JSON store
 * (payments, anticipos, cashbox, service, price, physcount, reception,
 * terminal, operator) into one newest-first list. Entries keep each store's
 * raw fields plus an injected `feature` tag; this is the durable "who did
 * what, when" trail for the write layer (a reversal deletes the ERP rows,
 * but never these entries).
 */

/** One merged audit entry. Fields beyond the common ones vary per feature. */
export interface WriteAuditEntry {
  feature: string;
  at?: string;
  user?: string;
  action?: string;
  result?: string;
  [key: string]: unknown;
}

export interface WriteAuditResponse {
  features: string[];
  entries: WriteAuditEntry[];
  read_errors: string[];
}

export async function getWriteAudit(
  feature?: string,
  limit?: number,
): Promise<WriteAuditResponse> {
  const params = new URLSearchParams();
  if (feature) params.set('feature', feature);
  if (limit) params.set('limit', String(limit));
  const qs = params.toString();
  const res = await fetch('/api/write-audit' + (qs ? `?${qs}` : ''), {
    credentials: 'same-origin',
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `HTTP ${res.status}`);
  }
  return (await res.json()) as WriteAuditResponse;
}
